import React, { useMemo } from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import { FormattedMessage } from "react-intl";
import { unitPrice } from "../../../../../../../../../../utils/product";


const OrderItemPrices = props =>{
    useStyles(cls);
    const { orderItem, orderProducts, priceTotal } = props;

    const orderCount = useMemo(() =>{
        if(orderProducts?.length > 0){
            return orderProducts?.reduce((previousValue, currentValue) =>{
                return previousValue + (currentValue?.quantity || currentValue?.qty)
            }, 0);
        }
    }, [orderProducts]);

    return <div className={cls.OrderItemPrices}>
        <span className={cls.NumberCon}>
            <span>{orderCount} </span>
            <span><FormattedMessage id="item" defaultMessage="Item" />(s):<FormattedMessage id="total" defaultMessage="Total" /></span>
        </span>

        <span className={cls.PricesCon}>
            <span className={cls.Total}>{unitPrice(priceTotal)}</span>

            {
                orderItem?.doublePointsMultiple > 0 && <span className={cls.DoublePoints}>
                    <span className={cls.DoublePointsNum}>x{orderItem.doublePointsMultiple}</span>
                </span>
            }
        </span>
    </div>
}

export default OrderItemPrices;